<template>
    <section id="content" :style="{'background-image': 'url(' + require('@/assets/sistem-pengawasan/background-CTA.png') + ')', 'background-size': 'cover'}" class="mt-10 py-5">
      <div class="d-flex flex-column gap-4 align-items-center justify-content-center">
        <h1 class="text-white display-4">{{ totalReports }}</h1>
        <h3 class="text-white">Jumlah Laporan Saat Ini</h3>
      </div>
    </section>
</template>

<script>
import axios from 'axios';
import { BASE_URL } from '@/store';

export default {
  name: "CTA",
  data() {
    return {
      totalReports: 0,
    }
  },
  created() {
    axios.get(`${BASE_URL}api/pengaduan/total`, { headers: { Authorization: localStorage.getItem('token') } })
      .then((res) => {
        if (res && res.data && res.data.status === 'success') {
          const total = typeof res.data.total === 'number' ? res.data.total : parseInt(res.data.total, 10) || 0;
          this.totalReports = new Intl.NumberFormat('id-ID').format(total);
        }
      })
      .catch((err) => {
        console.error('Failed to fetch total reports for CTA', err);
      });
  }
};
</script>